import React from "react";
import styled from "styled-components";

const PrivacyPolicy = () => {
  return (
    <Container>
      <Title>TOSS ENGLISH 2.0 개인정보 처리방침</Title>
      <Section>
        <SectionTitle>제 1 조 (목적)</SectionTitle>
        <Text>
          본 개인정보 처리방침은 <strong>[ORINAN]</strong> (이하 "회사")이 제공하는
          서비스(이하 "TOSS ENGLISH 2.0")를 이용하는 이용자의 개인정보를 보호하고, 관련 법령을
          준수하기 위해 마련되었습니다.
        </Text>
      </Section>

      <Section>
        <SectionTitle>제 2 조 (수집하는 개인정보 항목 및 방법)</SectionTitle>
        <SubTitle>1. 필수 수집 정보</SubTitle>
        <List>
          <ListItem>회원가입 시: 이름, 이메일 주소, 전화번호, 비밀번호</ListItem>
          <ListItem>서비스 이용 시: 과제 점수, 녹음 파일</ListItem>
        </List>
        <SubTitle>2. 선택적 수집 정보</SubTitle>
        <List>
          <ListItem>프로필 사진, 주소, 생년월일</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>제 3 조 (개인정보의 수집 및 이용 목적)</SectionTitle>
        <List>
          <ListItem>회원 관리: 본인 확인, 가입 의사 확인, 서비스 이용 관리</ListItem>
          <ListItem>서비스 제공: 맞춤형 콘텐츠 제공</ListItem>
          <ListItem>고객 지원: 문의사항 처리 및 불만 대응</ListItem>
          <ListItem>법적 의무 준수: 관계 법령에 따른 보관 의무 이행</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>제 4 조 (개인정보의 보유 및 이용기간)</SectionTitle>
        <Text>
          회사는 원칙적으로 개인정보의 수집 및 이용 목적이 달성된 후에는 해당 정보를
          지체 없이 파기합니다. 단, 관련 법령에 따라 일정 기간 동안 보관해야 하는 경우는
          아래와 같습니다.<br/>
          사용자 계정 삭제를 할 경우 아래의 기록을 제외한 모든 기록이 파기 됩니다
        </Text>
        <List>
          <ListItem>계약 또는 청약철회 등에 관한 기록: 5년</ListItem>
          <ListItem>대금 결제 및 재화 등의 공급에 관한 기록: 5년</ListItem>
          <ListItem>소비자의 불만 또는 분쟁 처리에 관한 기록: 3년</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>제 5 조 (사용자 계정 삭제의 방법)</SectionTitle>
        <Text>
          아래의 방법을 통해 계정 삭제가 가능합니다
        </Text>
        <List>
          <ListItem>1. 토스잉글리쉬 어플리케이션 열기</ListItem>
          <ListItem>2. 어플 로그인</ListItem>
          <ListItem>3. 내 정보 클릭</ListItem>
          <ListItem>4. 계정 삭제 버튼 클릭</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>제 6 조 (개인정보 보호책임자 및 문의처)</SectionTitle>
        <Text>
          개인정보 보호와 관련한 문의는 아래의 담당자에게 연락해 주세요.
        </Text>
        <List>
          <ListItem>
            <strong>개인정보 보호책임자:</strong> [조우빈]<br/>
            <strong>이메일: dnqlsdnqls529@orinan.kr</strong>
          </ListItem>
        </List>
      </Section>

      <Footer>
        최종 수정일: <strong>[2025-03-26]</strong>
      </Footer>
    </Container>
  );
};

export default PrivacyPolicy;


const Container = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #333;
  border-bottom: 2px solid #fd841f;
  padding-bottom: 5px;
  margin-bottom: 10px;
`;

const SubTitle = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
  color: #555;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #666;
`;

const List = styled.ul`
  padding-left: 20px;
`;

const ListItem = styled.li`
  font-size: 16px;
  color: #444;
  margin-bottom: 5px;
  list-style-type: disc;
`;

const Footer = styled.footer`
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #ddd;
`;
